export default "__VITE_ASSET__BIN7koJ4__"